import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportTxtService {

  constructor() { }

  exportAsTxtFile(data: any[], fileName: string, headers: string[]): void {
    let fileContent = '';

    if (headers && headers.length > 0) {
      const headerLine = headers.join('\t');
      fileContent += headerLine + '\n';
    }

    const dataLines = data.map(row => {
      if (headers && headers.length > 0) {
        return headers.map(header => row[header]).join('\t');
      } else {
        return Object.values(row).join('\t');
      }
    });

    fileContent += dataLines.join('\n');
    
    const blob = new Blob([fileContent], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${fileName}.txt`);
  }
}